import { Injectable } from '@angular/core';
import {fromBlob, blobToURL, fromURL} from 'image-resize-compress';

@Injectable({
  providedIn: 'root'
})
export class ImageCompressService {
  constructor() {
  }

  async compressBlob(blob: string, reduceSize: boolean, maxWidthHeight: number): Promise<string> {
    const quality = 100; // For webp and jpeg formats
    let width: 'auto' | number = 'auto'
    if (reduceSize) {
      width = await this.getWidthResizeRatio(blob, maxWidthHeight); // Original width
    }
    const height = 'auto'; // Original height
    const format = 'jpeg'; // Output format

    const resizedBlob = await fromURL(blob, quality, width, height, format);
    const url = await blobToURL(resizedBlob);
    const size = await this.getImageSize(url as string)
    console.log("Compressed image to: " + size.width + "x" + size.height)

    return url as string
  }

  async getWidthResizeRatio(blob: string, maxSize): Promise<number> {
    const size = await this.getImageSize(blob)
    console.log("Image is: " + size.width + "x" + size.height)
    if (size.width < maxSize && size.height < maxSize) {
      return size.width;
    }
    const scale = maxSize / Math.max(size.width, size.height);
    return scale * size.width
  }

  getImageSize(base64: string): Promise<{ width: number; height: number }> {
    return new Promise(resolve => {
      const img = new Image();
      img.onload = () => {
        resolve({
          width: img.naturalWidth,
          height: img.naturalHeight
        });
      };
      img.src = base64;
    });
  }
}
